module.exports = {"name":"hlsjs","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.2","built":"2018-05-16","repo":"https://bitbucket.org/npaw/hlsjs-adapter-js","libVersion":"6.2.6","features":{"buffer":"native","seek":"native","getters":["getPlayhead","getPlayrate","getDroppedFrames","getDuration","getBitrate","getRendition","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0